/* LoadingItem.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0jFU0Vb1xp%7Bheight%3A150px%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._1z0ZYFdnbC%20%3Ediv%7Bflex-grow%3A0%7D%0A._1UPrH0dnbC%20%3Ediv%7Bflex-shrink%3A0%7D%0A._4ims5nIZbP%20%3Ediv%7Bflex-basis%3Aauto%7D");







import Spinner from '@atlaskit/spinner/spinner';
import { AbstractItem } from './AbstractItem';
import { sizes } from './EmojiPickerSizes';
const emojiPickerSpinner = null;
export class LoadingItem extends AbstractItem<{}> {
  constructor() {
    super({}, sizes.loadingRowHeight);
  }
  renderItem = (): JSX.Element => <div className={ax(["_3iDTPbQ4SZ _39xV02N91d _0jFU0Vb1xp _37wbyuDIqT _0hPCNLDIqT _1z0ZYFdnbC _1UPrH0dnbC _4ims5nIZbP"])}>
			<div>
				<Spinner size="medium" />
			</div>
		</div>;
}